import { useState, useEffect } from 'react';

const COOKIE_KEY = 'swasthya_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = (accepted: boolean) => {
    localStorage.setItem(COOKIE_KEY, accepted ? 'accepted' : 'declined');
    setLeaving(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[200] transition-transform duration-400 ${
        leaving ? 'translate-y-full' : 'translate-y-0'
      }`}
    >
      <div className="bg-stone-900/95 backdrop-blur-sm border-t border-stone-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            {/* Text */}
            <div className="flex items-start gap-3 flex-1">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-shield-check-line text-sage-400 text-base" style={{ color: '#8aab8a' }}></i>
              </div>
              <p className="text-stone-300 text-sm leading-relaxed">
                We use cookies to enhance your experience on our retreat website — for analytics, functionality, and to remember your preferences.{' '}
                <a
                  href="#"
                  className="underline underline-offset-2 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  style={{ color: '#a8c5a8' }}
                >
                  Learn more
                </a>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 shrink-0">
              <button
                onClick={() => dismiss(false)}
                className="px-5 py-2 rounded-full text-sm font-medium text-stone-400 hover:text-stone-200 border border-stone-600 hover:border-stone-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Decline
              </button>
              <button
                onClick={() => dismiss(true)}
                className="px-5 py-2 rounded-full text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap"
                style={{ backgroundColor: '#8aab8a', color: '#1a1a1a' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#7a9b7a')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#8aab8a')}
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
